export default __webpack_public_path__ + "static/1.2_EN-4d107a9e491328c71c13d936f65c0b76.webp";